import { graphql } from "gatsby";
import React, { useCallback } from "react";
import { Collapse } from "react-collapse";
import Client from "shopify-buy";
import xss from "xss";

import NumberPicker from "../components/NumberPicker";
import SlideShow from "../components/SlideShow";
import SubPage from "../components/SubPage";
import App_Store_Icon from "../images/svg/App_Store.svg";
import Google_Play_Icon from "../images/svg/Google_Play.svg";
import * as styles from "../styles/productTemplate.module.css";
import { SEO } from "../components/SEO";
import { getImage } from "gatsby-plugin-image";

const appStoreIcons = () => (
  <div className={styles.app_store_icons_container}>
    <a href="https://play.google.com/store/apps/details?id=com.nexhub">
      <Google_Play_Icon />
    </a>
    <a href="https://apps.apple.com/us/app/nexhub/id1531029973">
      <App_Store_Icon />
    </a>
  </div>
);

const purchaseSection = (
  quantity: number,
  price: any,
  setQuantity: (q: number) => void,
  onPurchase: () => void
) => {
  return (
    <>
      <p style={{ fontSize: 20 }}>{`$${price.amount} ${price.currencyCode}`}</p>
      <NumberPicker
        decrement={() => setQuantity(quantity > 1 ? quantity - 1 : quantity)}
        increment={() => setQuantity(quantity < 99 ? quantity + 1 : quantity)}
        value={quantity}
      />

      <button id="purchase-item-button" className="button button-secondary" onClick={onPurchase}>
        Purchase
      </button>
    </>
  );
};

const Template = ({ data }: { data: any }) => {
  const [quantity, setQuantity] = React.useState(1);
  const [moreInfo, setMoreInfo] = React.useState(false);

  const { markdownRemark } = data;
  const { frontmatter, html } = markdownRemark;
  const productDesc = data.shopifyProduct.descriptionHtml;
  const productTitle = data.shopifyProduct.title;
  const productTags = data.shopifyProduct.tags;
  const productImages = data.shopifyProduct.images.map(
    (x: any) => getImage(x.localFile)
  );
  const purchaseCallback = useCallback(() => {
    const client = Client.buildClient({
      domain: "nexushealthid.myshopify.com",
      storefrontAccessToken: "4dcbaa9c4ccf75f37616072e248b4fdf",
    });

    const lineItemsToAdd = [
      {
        variantId: data.shopifyProduct.variants[0].storefrontId,
        quantity: quantity,
      },
    ];

    client.checkout
      .create()
      .then((checkout: any) => {
        console.log(checkout);
        return client.checkout.addLineItems(checkout.id, lineItemsToAdd);
      })
      .then((checkout: any) => {
        console.log(checkout);
        window.location.href = checkout.webUrl;
      });
  }, [quantity]);
  return (
    <SubPage>
      <SEO title={frontmatter.title} description={frontmatter.description} image={frontmatter.image} />
      <div className={styles.container}>
        <div className={styles.slide_show}>
          <SlideShow
            smallArrows={true}
            piBottom={true}
            images={productImages}
          />
        </div>
        <div className={styles.product_title}>
          <h1 className={styles.summary_h1}>{productTitle}</h1>
        </div>
        <div className={styles.summary_section}>
          <div
            dangerouslySetInnerHTML={{ __html: xss(productDesc) }}
            className={styles.summary_text}
          ></div>

          <div className={styles.summary_checkout_container}>
            {productTags.includes("App")
              ? appStoreIcons()
              : purchaseSection(
                  quantity,
                  data.shopifyProduct.priceRangeV2.minVariantPrice,
                  setQuantity,
                  purchaseCallback
                )}
          </div>
        </div>
      </div>

      <hr style={{ marginTop: 20, marginBottom: 40 }} />

      <Collapse isOpened={moreInfo}>
        <div dangerouslySetInnerHTML={{ __html: xss(html) }} />
      </Collapse>

      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <button
          className="button button-secondary"
          onClick={() => setMoreInfo(!moreInfo)}
        >
          {moreInfo ? "Hide" : "More Info"}
        </button>
      </div>
    </SubPage> 
  );
};

export default Template;

export const pageQuery = graphql`
  query ($slug: String!, $product: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        date(formatString: "YYYY-MM-DD")
        slug
        title
        product
        description
        image
      }
    }
    shopifyProduct(handle: { eq: $product }) {
      title
      handle
      tags
      id
      storefrontId
      descriptionHtml
      variants {
        id
        storefrontId
        shopifyId
      }
      images {
        localFile {
          childImageSharp {
            gatsbyImageData(
            quality: 50
            placeholder: DOMINANT_COLOR
            layout: CONSTRAINED
          )
          }
        }
      }
      
      priceRangeV2 {
        minVariantPrice {
          amount
          currencyCode
        }
      }
    }
  }
`;
